import { PhoneCancelIcon } from './PhoneCancelIcon';

/**
 * author: Patricia Cadenas
 * id C97B6119-5EB1-4930-AEFA-7E3E216D3875
 * name phone-cancel
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/phone-cancel.svg
 * tags
 * - Cellphone / Phone 
 */
export const PhoneBlockIcon = PhoneCancelIcon;
export default PhoneBlockIcon